export default __webpack_public_path__ + "static/media/GenericUser.841c0e44.svg";